import React, { useEffect, useState, Component } from "react";
import "./home_middle.css";

import singam from "./Im/singam.png"
import boss from "./Im/boss.png"
import sivaji from "./Im/sivaji.png";
import vijay from "./Im/vijay.png";
import telugu_h from "./Im/telugu_h.png"
import o_im from "./Im/o_im.png"
import ynot from "./Im/ynot.jpg"
import hundred from "./Im/hundred-point.png"
import reliance from "./Im/reliance.png";
import avm from "./Im/avm.jpg"
import tsl from "./Im/tsl.png"
import mango from "./Im/mango.png"
import right from "./Im/right.png"
import "./home_middle.css";
import introvideo from "./Im/Col1.mp4"
import poster from "./Im/maranamasss.png"
import { Link, BrowserRouter as Router, Route, Switch, useRouteMatch, useHistory } from "react-router-dom";
import Collections_sub from "../../Pages/collections-sub/Collections_sub";
import axios from "axios";

import Top_selling_cards from "./Top_selling_cards";
import Countdown from 'react-countdown';
import Nav_path from '../Navbar_module/Nav_path';
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import kabali1 from "./Im/kabali1.jpg"
import kabali2 from "./Im/kabali2.jpg"
import Mer from "./Im/Mer.png"
import Vk from "./Im/Vk.png"
import si from "./Im/si.png"
import f1 from "./Im/1.png"
import thumb_vivek from "./Im/thumb_vivek.JPG"
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import 'react-loading-skeleton/dist/skeleton.css'



function Movies({ hours, minutes, seconds, completed }) {
    let history = useHistory();
    const responsive = {
        superLargeDesktop: {
            // the naming can be any, depends on you.
            breakpoint: { max: 4000, min: 3000 },
            items: 1
        },
        desktop: {
            breakpoint: { max: 3000, min: 1024 },
            items: 1
        },
        tablet: {
            breakpoint: { max: 1024, min: 464 },
            items: 1
        },
        mobile: {
            breakpoint: { max: 464, min: 0 },
            items: 1
        }
    };


    const Completionist = () => <span>0:0:0</span>;

    // Renderer callback with condition
    const renderer = ({ hours, minutes, seconds, completed }) => {
        if (completed) {
            // Render a completed state
            return (
                <Nav_path />
            )
        } else {
            // Render a countdown
            return
        }
    };

  
          setTimeout(function () {
              const display = document.getElementById("skeleton_loader_movies").style.display;
              if (display == "") {
                  document.getElementById("skeleton_loader_movies").style.display = "none";
                  document.getElementById("data_loader_movies").style.display = "";
                  console.log("Skeleton Function Executed...")

              }
          }, 3000);
  



    return (

        <div className="movies">
            <div className="movies-grid">
                <Carousel
                    responsive={responsive}
                    autoPlay={false}
                    autoPlaySpeed={5000}
                    infinite={true}
                    containerClass='movies-slider'
                    removeArrowOnDeviceType={["desktop", "tablet", "mobile"]}
                >
                    <div className="singam">
                        <img onClick={() => {
                            history.push("/PasumaiNayaganVivek");
                        }} className="singam" src={thumb_vivek} alt="Logo" />

                        <h1 style={{ fontSize: '60px' }} className="singam-text">Pasumai Nayagan Vivek</h1>

                    </div>
                </Carousel>

                <div className="movie-list" id="skeleton_loader_movies" style={{ display: '', paddingBottom:'20px' }}>
                    <div class="skeletonbox2" style={{paddingTop:'5px'}}>
                        <div className="movie-block" >
                            <Skeleton baseColor="#080824" style={{borderRadius: '20px'}} highlightColor="#b1b2bc" height={243} />
                        </div>
                        <div  className="movie-block">
                            <Skeleton baseColor="#080824" style={{borderRadius: '20px'}} highlightColor="#b1b2bc" height={243} />
                        </div>
                    </div>
                    <div className="skeletonloader" >
                        <div className="movie-block2">
                            <Skeleton baseColor="#080824" style={{borderRadius: '20px'}} highlightColor="#b1b2bc" height={243} />
                        </div>
                        <div className="movie-block2">
                            <Skeleton baseColor="#080824" style={{borderRadius: '20px'}} highlightColor="#b1b2bc" height={243} />
                        </div>
                    </div>
                </div>

                <div className="movie-list" id="data_loader_movies" style={{ display: 'none' }}>
                    <div className="movie-block" >
                        <img onClick={() => {
                            history.push("/chandramukhi");
                        }} className="movie-block" src={f1} alt="Logo" />
                        <h3 className="movie-text">Chandramukhi</h3>
                        <div className="time"><h3 className="tstamp">Latest</h3></div>
                    </div>
                    <div className="movie-block">
                        <img onClick={() => {
                            history.push("/sivaji");
                        }} className="movie-block" src={si} alt="Logo" />
                        <h3 className="movie-text">Sivaji</h3>
                        <div className="time"><h3 className="tstamp">Trending</h3></div>
                    </div>
                    <div className="movie-block2">
                        <img onClick={() => {
                            history.push("/Kabali");
                        }} className="movie-block" src={kabali2} alt="Logo" />
                        <h3 className="movie-text">Kabali</h3>
                        <div className="time"><h3 className="tstamp">Latest</h3></div>
                    </div>
                    <div className="movie-block2">
                        <img onClick={() => {
                            history.push("#");
                        }} className="movie-block" src={Mer} alt="Logo" />
                        <h3 className="movie-text">Mersal</h3>
                        <div className="time"><h3 className="tstamp">Coming soon</h3></div>
                    </div>
                </div>

            </div>
        </div>
               

               
           
    )
}

export default Movies
